import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@fluentui/react-components';
import { ArrowLeft20Regular, QuestionCircle24Regular } from '@fluentui/react-icons';
import EmptyState from '../components/ui/EmptyState';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    return (
        <EmptyState
            icon={<QuestionCircle24Regular />}
            title="Страница не найдена"
            description="Такого адреса нет. Возможно, опрос был удалён или ссылка устарела."
            actions={(
                <Button appearance="primary" icon={<ArrowLeft20Regular />} onClick={() => navigate('/polls')}>
                    К списку опросов
                </Button>
            )}
        />
    );
};

export default NotFoundPage;
